import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import TabMaster from "#core/components/tab/TabMaster"
import ErrorResponse from "#core/pages/ErrorResponse"
import { validateCompetenceQuestions } from "#evaluation/components/evaluation/Evaluation"
import { EvaluationQuestions } from "#evaluation/components/evaluation/EvaluationQuestions/EvaluationQuestions"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import Kpis from "#performance-evaluation/components/kpis/Kpis"
import {
	evaluationEvaluatorPut,
	evaluationQuestionsGet,
} from "#performance-evaluation/services/api"
import { Box, Button, Paper, Typography } from "@mui/material"
import { useReloadRefresh } from "app/reload"
import { ChangeTitle } from "Components/menu/funciones"
import { useMemo, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"

export default function Form() {
	ChangeTitle("Evaluacion de Desempeño")
	const navigate = useNavigate()
	const { refresh } = useReloadRefresh()
	const paramsUrl = useParams()
	const evaluationEvaluatorId = paramsUrl["evaluationEvaluatorId"]
	const params = useMemo(
		() => ({
			evaluator_id: evaluationEvaluatorId,
		}),
		[evaluationEvaluatorId],
	)
	const { data, loading, error } = useApi(evaluationQuestionsGet, {
		params,
		autoFetch: true,
	})
	const { self_evaluation, is_active } = useMemo(() => data || {}, [data])

	const success = () => {
		refresh()
		navigate(-1)
	}
	const { fetch } = useApiSend(evaluationEvaluatorPut, { success })

	// const [competences, setCompetences] = useState({})
	const [competences, setCompetences] = useState({})
	const [kpis, setKpis] = useState({})
	const [tab, setTab] = useState("Competencias")

	const questions = useMemo(() => {
		return (
			data?.questions.map((item) => {
				console.log("🚀 ~ Form ~ item:", item)
				item.competencia = item.id
				return item
			}) || []
		)
	}, [data])
	console.log("🚀 ~ Form ~ questions:", questions)

	const listTabs = [
		{
			id: "Competencias",
			label: "Competencias",
			content: (
				<EvaluationQuestions
					questionRating={() => {}}
					setValues={setCompetences}
					values={competences}
					questionsData={questions}
					perfilPuesto={data?.perfil_puesto}
					noComment
				/>
			),
		},
	]
	if (!self_evaluation)
		listTabs.push({
			id: "kpis",
			label: "KPI'S",
			content: (
				<Kpis
					setValueK={setKpis}
					valueK={kpis}
					kpis={data?.kpis || []}
					perfilPuesto={data?.perfil_puesto}
				/>
			),
		})
	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	if (!is_active) {
		return (
			<Box textAlign="center" mt={4}>
				<Typography variant="h6">
					La evaluación de desempeño ya ha sido enviada y no puede ser editada.
				</Typography>
				<Button variant="contained" onClick={() => navigate(-1)} sx={{ mt: 2 }}>
					Regresar
				</Button>
			</Box>
		)
	}
	return (
		<Box display="flex" flexDirection="column" gap={2} component={Paper} pt={2}>
			{/* <FormHeader /> */}
			<TabMaster listTabs={listTabs} selectedTab={tab} setSelectedTab={setTab} />
			<div style={{ display: "flex", justifyContent: "center", padding: "16px" }}>
				<Button
					onClick={() => {
						const dataSend = {
							competences,
							kpis,
						}
						console.log("dataSend", dataSend)
						if (!validateData(dataSend, self_evaluation)) {
							return
						}
						fetch(evaluationEvaluatorId, dataSend)
					}}
				>
					Enviar
				</Button>
			</div>
		</Box>
	)
}

const validateData = (data, self_evaluation) => {
	if (!validateCompetenceQuestions(data?.competences)) return
	if (!self_evaluation) if (!validateKpis(data?.kpis)) return
	return true
}
const validateKpis = (data) => {
	if (Object.keys(data).length === 0) {
		toast.error(`Se requiere de los KPI'S`)
		return
	}
	for (let key of Object.keys(data || {})) {
		const value = data[key]
		if (value === null || value === undefined || value === "") {
			toast.error(`El KPI con id ${key} requiere un valor`)
			return
		}
		if (isNaN(value)) {
			toast.error(`El valor del KPI  debe ser un número`)
			return
		}
		if (value < 0 || value > 100) {
			toast.error(`El valor del KPI  debe estar entre 0% y 100%`)
			return
		}
	}

	return true
}
